import type { CookieConsentDraft } from './cookie-consent.types';
import './cookie-consent.scss';

type CookieConsentSettingsProps = {
  title: string;
  necessaryLabel: string;
  necessaryHint: string;
  analyticsLabel: string;
  analyticsHint: string;
  marketingLabel: string;
  marketingHint: string;
  alwaysActiveLabel: string;
  backLabel: string;
  saveLabel: string;
  draft: CookieConsentDraft;
  onChange: (next: CookieConsentDraft) => void;
  onBack: () => void;
  onSave: () => void;
};

export function CookieConsentSettings({
  title,
  necessaryLabel,
  necessaryHint,
  analyticsLabel,
  analyticsHint,
  marketingLabel,
  marketingHint,
  alwaysActiveLabel,
  backLabel,
  saveLabel,
  draft,
  onChange,
  onBack,
  onSave,
}: CookieConsentSettingsProps) {
  return (
    <div className="cookie-consent__panel" role="dialog" aria-labelledby="cookie-settings-title">
      <h2 id="cookie-settings-title" className="cookie-consent__title">
        {title}
      </h2>
      <hr className="cookie-consent__divider" />

      <ul className="cookie-consent__categories">
        <li className="cookie-consent__category">
          <div className="cookie-consent__category-copy">
            <span className="cookie-consent__category-title">{necessaryLabel}</span>
            <span className="cookie-consent__category-hint">{necessaryHint}</span>
          </div>
          <span className="cookie-consent__badge">{alwaysActiveLabel}</span>
        </li>

        <li className="cookie-consent__category">
          <div className="cookie-consent__category-copy">
            <span className="cookie-consent__category-title">{analyticsLabel}</span>
            <span className="cookie-consent__category-hint">{analyticsHint}</span>
          </div>
          <label className="cookie-consent__switch">
            <input
              type="checkbox"
              checked={draft.analytics}
              onChange={event =>
                onChange({ ...draft, analytics: event.target.checked })
              }
            />
            <span className="cookie-consent__switch-ui" />
          </label>
        </li>

        <li className="cookie-consent__category">
          <div className="cookie-consent__category-copy">
            <span className="cookie-consent__category-title">{marketingLabel}</span>
            <span className="cookie-consent__category-hint">{marketingHint}</span>
          </div>
          <label className="cookie-consent__switch">
            <input
              type="checkbox"
              checked={draft.marketing}
              onChange={event =>
                onChange({ ...draft, marketing: event.target.checked })
              }
            />
            <span className="cookie-consent__switch-ui" />
          </label>
        </li>
      </ul>

      <div className="cookie-consent__actions cookie-consent__actions--settings">
        <button
          type="button"
          className="cookie-consent__btn cookie-consent__btn--ghost"
          onClick={onBack}
        >
          {backLabel}
        </button>
        <button
          type="button"
          className="cookie-consent__btn cookie-consent__btn--solid"
          onClick={onSave}
        >
          {saveLabel}
        </button>
      </div>
    </div>
  );
}
